import { ComponentCategory, type ComponentMeta } from "@mijalowcode/types";
import type { CSSProperties } from "react";

const DEFAULT_CONTAINER_STYLE = {
  width: "100%",
  minHeight: 100,
  overflowX: "hidden",
  boxSizing: "border-box",
} satisfies CSSProperties;

export const ContainerMeta: ComponentMeta = {
  componentName: "Container",
  package: "@mijadesign/mjui-react",
  title: "容器",
  description: "用于包裹和布局移动端子物料",
  category: ComponentCategory.LAYOUT,
  icon: "AppstoreOutlined",
  visibleInComponentPanel: true,
  canHaveChildren: true,
  props: [],
  defaultStyle: DEFAULT_CONTAINER_STYLE,
  eventSources: [
    {
      name: "click",
      label: "点击",
      trigger: "dom",
    },
  ],
  snippet: {
    componentName: "Container",
    package: "@mijadesign/mjui-react",
    props: {},
    style: DEFAULT_CONTAINER_STYLE,
    children: [],
  },
};
